import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import About from "@/components/About";
import PhoneRepair from "@/components/PhoneRepair";
import Fiscalization from "@/components/Fiscalization";
import Bookshop from "@/components/Bookshop";
import Products from "@/components/Products";
import ContactInfo from "@/components/ContactInfo";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Nav />
      <Hero />
      <About />
      <PhoneRepair />
      <Fiscalization />
      <Bookshop />
      <Products />
      <ContactInfo />
      <Footer />
      <CartDrawer />
    </main>
  );
}
